import { createAction, props } from '@ngrx/store';
import { FreightPayer } from './models/FreightPayer';

export const loadFreightPayers = createAction('[Freight Payer] Load Freight Payers');

export const loadFreightPayersSuccess = createAction(
    '[Freight Payer] Load Freight Payers Success',
    props<{ freightPayers: FreightPayer[] }>()
);

export const loadFreightPayersFailure = createAction(
    '[Freight Payer] Load Freight Payers Failure',
    props<{ error: string }>()
);

export const addFreightPayer = createAction(
    '[Freight Payer] Add Freight Payer',
    props<{ freightPayer: FreightPayer }>()
);

export const addFreightPayerSuccess = createAction(
    '[Freight Payer] Add Freight Payer Success',
    props<{ freightPayer: FreightPayer }>()
);

export const addFreightPayerFailure = createAction(
    '[Freight Payer] Add Freight Payer Failure',
    props<{ error: string }>()
);

export const updateFreightPayer = createAction(
    '[Freight Payer] Update Freight Payer',
    props<{ freightPayer: FreightPayer }>()
);

export const updateFreightPayerSuccess = createAction(
    '[Freight Payer] Update Freight Payer Success',
    props<{ freightPayer: FreightPayer }>()
);

export const updateFreightPayerFailure = createAction(
    '[Freight Payer] Update Freight Payer Failure',
    props<{ error: string }>()
);

export const deleteFreightPayer = createAction(
    '[Freight Payer] Delete Freight Payer',
    props<{ freightPayerId: string }>()
);

export const deleteFreightPayerSuccess = createAction(
    '[Freight Payer] Delete Freight Payer Success',
    props<{ freightPayerId: string }>()
);

export const deleteFreightPayerFailure = createAction(
    '[Freight Payer] Delete Freight Payer Failure',
    props<{ error: string }>()
);